import AttachMoney from '@material-ui/icons/AttachMoney';

import List from './List2';

export default {
  list: List,
  icon: AttachMoney,
};
